import './Icon_Refresh.css';
import {ReactComponent as RefreshIcon} from './Icons_Transform_Outline_Brand.svg';
function Icon_Refresh() {
  return (
    
      <div className='refresh-icon-container'>
          <RefreshIcon className="refresh-icon-svg" />
          </div>

            
  );
}

export default Icon_Refresh;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-ccw-icon lucide-refresh-ccw">
// <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>